
import {
  reliability,
  features,
  popularServices,
  questions,
} from "~/data/compute";
import Modal from "~/components/rebranding/modal/Modal.vue";
import DiffrenceVPS from "~/components/vps/DiffrenceVPS.vue";

export default {
  data() {
    return {
      copiedIndex: null,
      activeSection: "",
      FormTitle: "",
      solotionTab: 0,
      reliability,
      features,
      popularServices,
      questions,
    };
  },
  components: {
    Modal,
    DiffrenceVPS,
  },
  methods: {
    handleScroll(e) {
      if (document.documentElement.scrollTop > 550) {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center floating";
      } else {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center";
      }
    },
  },
  beforeMount() {
    if (window.innerWidth >= 960)
      window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    if (window.innerWidth >= 960)
      window.removeEventListener("scroll", this.handleScroll);
  },
  head() {
    return {
      title: "رایانش ابری آبالون | سرور و دیتاسنتر بر بستر ابر",
      meta: [
        {
          name: "description",
          content:
            "رایانش ابری آبالون | زیرساخت امن و پایدار در سراسر ایران | سرور ابری VPS | دیتاسنتر ابری VPC |‌ تحویل فوری، مقیاس‌پذیری لحظه‌ای و پشتیبانی شبانه‌روزی",
        },
        {
          name: "keywords",
          content: "رایانش ابری آبالون, سرور ابری, دیتاسنتر ابری",
        },
        {
          property: "og:url",
          content: "https://abalon.cloud/compute",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:locale",
          content: "fa",
        },
        {
          property: "og:title",
          content: "رایانش ابری آبالون | سرور و دیتاسنتر بر بستر ابر",
        },
        {
          property: "og:description",
          content:
            "رایانش ابری آبالون | زیرساخت امن و پایدار در سراسر ایران | سرور ابری VPS | دیتاسنتر ابری VPC |‌ تحویل فوری، مقیاس‌پذیری لحظه‌ای و پشتیبانی شبانه‌روزی",
        },
        {
          property: "og:image",
          content: "/images/og-image.png",
        },
        {
          property: "og:logo",
          content: "/images/logo.svg",
        },
        {
          name: "twitter:card",
          content: "summary",
        },
        {
          name: "twitter:url",
          content: "https://abalon.cloud/compute",
        },
        {
          name: "twitter:title",
          title: "رایانش ابری آبالون | سرور و دیتاسنتر بر بستر ابر",
        },
        {
          name: "twitter:description",
          content:
            "رایانش ابری آبالون | زیرساخت امن و پایدار در سراسر ایران | سرور ابری VPS | دیتاسنتر ابری VPC |‌ تحویل فوری، مقیاس‌پذیری لحظه‌ای و پشتیبانی شبانه‌روزی",
        },
        {
          name: "format-detection",
          content: "telephone=no",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://abalon.cloud/compute",
        },
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "سرویس‌های رایانش ابری آبالون شامل چه مواردی می‌شود؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "رایانش ابری آبالون شامل سرورهای ابری مقیاس‌پذیر (VPS) و دیتاسنترهای ابری اختصاصی (VPC) است. این سرویس‌ها امکان راه‌اندازی سریع زیرساخت، مدیریت یکپارچه و مقیاس‌پذیری لحظه‌ای منابع را در اختیار شما قرار می‌دهند.",
                },
              },
              {
                "@type": "Question",
                name: "تفاوت سرور ابری (VPS) و دیتاسنتر ابری (VPC) چیست؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "سرور ابری (VPS) یک ماشین مجازی قدرتمند است که در کمتر از یک دقیقه آماده استفاده می‌شود و گزینه‌ای مقرون‌به‌صرفه برای اجرای سرویس‌هاست. دیتاسنتر ابری (VPC) محیطی اختصاصی و ایزوله است که به شما امکان می‌دهد تعداد نامحدودی ماشین مجازی ایجاد کنید، آن‌ها را در یک پنل واحد مدیریت کنید و معماری‌های پیچیده سازمانی خود را مانند یک دیتاسنتر فیزیکی، روی بستر ابر پیاده‌سازی کنید.",
                },
              },
              {
                "@type": "Question",
                name: "آیا در سرویس‌های رایانش ابری، امکان ارتقا یا کاهش لحظه‌ای منابع سرور ابری وجود دارد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله. در رایانش ابری آبالون می‌توانید منابع سرور مانند CPU، RAM و فضای ذخیره‌سازی را به‌صورت لحظه‌ای تغییر دهید و هزینه‌ها را بر اساس نیاز خود مدیریت کنید.",
                },
              },
              {
                "@type": "Question",
                name: "مزیت استفاده از رایانش ابری آبالون نسبت به خرید سخت‌افزار فیزیکی چیست؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "با رایانش ابری آبالون، می‌توانید سرویس‌ها را در چند دقیقه راه‌اندازی کنید و بدون نیاز به نیروی متخصص، تمام ماشین‌های مجازی خود را در یک پنل مدیریت کنید. دیگر ظرفیت محدود سخت‌افزار را تجربه نخواهید کرد، زیرا امکان ایجاد تعداد نامحدود ماشین مجازی و آی‌پی عمومی، انتقال آسان بین سطوح کیفی مختلف و همچنین طراحی معماری‌های سفارشی به همراه مدیریت شبکه، فایروال و دیسک‌های مجازی به طور کامل در اختیار شماست.",
                },
              },
            ],
          },
        },
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org/",
            "@type": "Review",
            itemReviewed: {
              "@type": "CreativeWorkSeries",
              name: "خدمات رایانش ابری آبالون",
            },
            author: {
              "@type": "Person",
              name: "Amirhosein",
            },
            reviewRating: {
              "@type": "Rating",
              ratingValue: "4.9",
              bestRating: "5",
            },
            publisher: {
              "@type": "Organization",
              name: "Abalon Cloud Solutions",
            },
          },
        },
      ],
    };
  },
};
